import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import Heading from '@atlaskit/heading';
import { token } from '@atlaskit/tokens';
import { fg } from '@atlassian/jira-feature-gating';

type Props = {
	title?: string;
	description?: ReactNode;
	children: ReactNode;
};

export const FeatureSection = ({ title, description, children }: Props) => {
	const headingLevel = fg('jsmca11y-564-update-section-headings') ? 'h2' : 'h5';
	return (
		<Wrapper>
			{Boolean(title) && (
				<Heading as={headingLevel} size="small">
					<Title>{title}</Title>
				</Heading>
			)}
			{Boolean(description) && <Description>{description}</Description>}
			<ContentWrapper>{children}</ContentWrapper>
		</Wrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	margin: `${token('space.400', '32px')} 0`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Title = styled.div({
	marginBottom: token('space.200', '16px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Description = styled.div({
	marginBottom: token('space.400', '32px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ContentWrapper = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'> :nth-of-type(n+1)': {
		marginTop: token('space.200', '16px'),
	},
});
